import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  @Input() text: any;
  @Input() checkboxValue: any;
  @Input() checked: boolean;
  @Input() type: 'checkmark' | 'hyphen';

  @Output() checkboxSelectedCallback = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  handleCheckboxSelected(event: any) {
    if (this.checkboxSelectedCallback) {
      this.checkboxSelectedCallback.emit({value: event.target.value, checked: event.target.checked});
    }
  }

}
